import { render, staticRenderFns } from "./confirmTipDialog.vue?vue&type=template&id=58caf3bb&"
import script from "./confirmTipDialog.vue?vue&type=script&lang=js&"
export * from "./confirmTipDialog.vue?vue&type=script&lang=js&"
import style0 from "./confirmTipDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58caf3bb')) {
      api.createRecord('58caf3bb', component.options)
    } else {
      api.reload('58caf3bb', component.options)
    }
    module.hot.accept("./confirmTipDialog.vue?vue&type=template&id=58caf3bb&", function () {
      api.rerender('58caf3bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/components/confirmTipDialog.vue"
export default component.exports